import { memo } from 'react';
import { Chip } from '@mui/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import DescriptionLoader from '../../Loader/Description/DescriptionLoader';
import styles from '../../publicationDetail.module.scss';
import { PublicationDescriptionProps } from '../../interfaces';

const PublicationDescription = ({
  type,
  publication,
  loading,
  selectedFeatures = []
}: PublicationDescriptionProps) => {
  const renderAdditionalFeatures = (features: any[]) => {
    if (!features || features.length === 0) {
      return <p className={styles.descriptionText}>No añadiste características adicionales aún</p>;
    }

    return (
      <div className={styles.featuresList}>
        {features.map((category: any) =>
          category.value
            .filter((item: any) => item.value === true)
            .map((item: any) => (
              <Chip
                key={item.code}
                label={item.name}
                className={styles.featureChip}
                sx={{
                  margin: '0 4px 4px 0',
                  height: '28px',
                  color: 'rgba(115, 115, 115, 1)',
                }}
              />
            ))
        )}
      </div>
    );
  };

  const renderSelectedFeatures = () => {
    if (selectedFeatures.length === 0) {
      return <p className={styles.descriptionText}>No añadiste características adicionales aún</p>;
    }

    return (
      <div className={styles.featuresList}>
        {selectedFeatures.map(({ name, code }: { name: string; code: string }) => (
          <Chip
            key={code}
            label={name}
            className={styles.featureChip}
            sx={{
              margin: '0 4px 4px 0',
              height: '28px',
              color: 'rgba(115, 115, 115, 1)',
            }}
          />
        ))}
      </div>
    );
  };

  if (loading) {
    return (
      <div className={styles.description}>
        <DescriptionLoader />
      </div>
    );
  }

  return (
    <>
      {/* Descripción del usuario */}
      {publication?.user_description && (
        <div className={styles.description}>
          <p className={styles.title}>Descripción</p>
          <p className={styles.content}>{publication.user_description}</p>
        </div>
      )}

      {/* Contenedor de descripción de venta */}
      {(type !== "salePost" || type === "salePost") && (
        <div className={styles.salePostContainer}>
          {/* Descripción del vehículo generada por IA */}
          {(publication?.chatgpt_description || type === "salePost") && (
            <div className={styles.vehicleDescription}>
              <div className={styles.descriptionHeader}>
                <p className={styles.title}>Descripción del vehículo</p>
                <p className={styles.subtitle}>
                  <AutoAwesomeIcon className={styles.svg} />
                  <span className={type === "salePost" ? styles.text : styles.textIA}>
                    Generado por Linze IA
                  </span>
                </p>
              </div>
              <p className={styles.descriptionText}>
                {type === "salePost" 
                  ? "Este espacio se va a completar con una descripción generada por la IA después de que publiques tu auto."
                  : publication.chatgpt_description
                }
              </p>
            </div>
          )}

          {/* Características adicionales */}
          <div className={styles.additionalFeatures}>
            <p className={styles.title}>Características adicionales</p>
            {type === "salePost" 
              ? renderSelectedFeatures()
              : renderAdditionalFeatures(publication?.additional_characters)
            }
          </div>
        </div>
      )}
    </>
  );
};

export default memo(PublicationDescription);
